import React, { FC } from 'react';
import { Config } from '../config/Config'
import { Navigate } from 'react-router';
import { getFromStorage } from '../utils/Helper';

interface PropType {
    component: React.FC;
}

const PrivateRoute: FC<PropType> = ({ component: Component }) => {

    if (getFromStorage({ key: "access_token" })) {
        return <Component />;
    }
    else {
        return <Navigate to={Config?.url + "/"} />;
    }
};

export default PrivateRoute;